import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BreakPoint, Color, FontSize } from '../../styles/constants';
import checkmark from '../../images/checkmark';

const Item = styled.div`
  display: flex;
`;

const Check = styled.div`
  background: ${props =>
    props.checked
      ? `${Color.border.blue} url(${checkmark}) no-repeat center center`
      : 'transparent'};
  background-size: 12px 9px;
  border: solid 2px
    ${props => (props.checked ? Color.border.blue : Color.border.gray)};
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  margin-right: 16px;
  height: 24px;
  width: 24px;

  @media (min-width: ${BreakPoint.desktop}) {
    height: 18px;
    width: 18px;
    margin-top: 3px;
    margin-right: 8px;
  }
`;

const Content = styled.div`
  color: ${props => (props.checked ? Color.text.darkGray : Color.text.gray)};
  cursor: pointer;
  flex: 1;
  font-size: ${FontSize.medium};
  line-height: 1.6875;
  text-align: left;

  @media (min-width: ${BreakPoint.desktop}) {
    font-size: ${FontSize.desktop.small};
  }

  @media (max-width: ${BreakPoint.small}) {
    font-size: ${FontSize.smallDevice.medium};
  }
`;

class CheckBoxItem extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(value, checked) {
    const { onChange } = this.context.checkBox;
    onChange(value, checked);
  }

  render() {
    const { selectedValues } = this.context.checkBox;
    const { label, value, ...rest } = this.props;
    const options = { checked: false };
    if (selectedValues.length > 0) {
      options.checked = selectedValues.indexOf(value) >= 0;
    }

    return (
      <Item
        onClick={() => this.handleClick(value, !options.checked)}
        {...options}
        {...rest}
      >
        <Check {...options} />
        <Content {...options}>
          {label.split('\n').map((item, key) => (
            <span key={key}>
              {item}
              <br />
            </span>
          ))}
        </Content>
      </Item>
    );
  }
}

CheckBoxItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]).isRequired,
};

CheckBoxItem.contextTypes = {
  checkBox: PropTypes.object,
};

export default CheckBoxItem;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/subComponents/CheckBox/CheckBoxItem.jsx